import { render, staticRenderFns } from "./轮播新闻.vue?vue&type=template&id=0059a98c&scoped=true"
import script from "./轮播新闻.vue?vue&type=script&lang=js"
export * from "./轮播新闻.vue?vue&type=script&lang=js"
import style0 from "./轮播新闻.vue?vue&type=style&index=0&id=0059a98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059a98c",
  null
  
)

export default component.exports